import * as React from 'react';
import * as mobxReact from 'mobx-react';
import { FormattedMessage, IntlShape } from 'react-intl';
import DefaultButton from '../../../../global/default-button/default-button';
import { CommonModal } from '../../../../global/modal/common/common-modal';
import { DefaultCloseModalButton } from '../../../../global/modal/common/common-close-modal-buttons';
import { withViewModel } from '../../../../../infrastructure/components/with-view-model';
import AllEventConfigurationVM from './all-events-configuration-modal.viewmodel';
import { AllEventConfigurationPresentation as AllEventConfiguration } from './all-events-configuration-modal.presentation';
import { cancelText } from '../../../../../constants/common-labels.constants';

export interface IGeneralRegistrationModalProps {
    accountId: number;
    eventId: number;
    onCancel: () => void;
    intl: IntlShape;
}

const AllEventConfigurationPresentation = mobxReact.observer(({vm}: {vm: AllEventConfigurationVM}) => {
    return (
            <CommonModal
                title={
                    <FormattedMessage
                        id='oe.connections.downloadEventConnections'
                        description='Download All Events Connections Popover header text'
                        defaultMessage='Download All Events Connections'
                    />
                }
                isOpen={true}
                isWide={true}
                onRequestClose={vm.onCancel}
                footer={
                    <div className='buttons-block buttons-block--from-right'>
                        <DefaultButton
                            text={
                                <FormattedMessage
                                    id='oe.common.export'
                                defaultMessage='Export'
                                description='Button text'
                                />
                            }
                            modifier={['fat', 'confirm-safe']}
                            onClick={vm.onExportCSV}
                        />
                        <DefaultCloseModalButton text={cancelText()} />
                    </div>
                }
            >
                <AllEventConfiguration vm={vm} />
            </CommonModal>
        );
    }
);

const AllEventConfigurationModalContainer = withViewModel(
    AllEventConfigurationPresentation,
    async (props: IGeneralRegistrationModalProps) => {
        const { accountId, eventId, onCancel, intl } = props;
        const allEventConfigurationVM = new AllEventConfigurationVM(
            accountId,
            eventId,
            onCancel,
            intl
        );

        await allEventConfigurationVM.setCsvColumns();

        return allEventConfigurationVM;
    }
);

export { AllEventConfigurationModalContainer as AllEventConfigurationModal, AllEventConfigurationPresentation };
